import React from 'react';
import { Box } from '@material-ui/core';
import { NoDataText } from 'src/pages/reportUsage/utils/reportUsage.styled';

const NoData = ({ padding, content, marginTop }) => {
    return (
        <Box bgcolor={'#F5F5F5'} minHeight={'200px'}>
            <NoDataText padding={padding} marginTop={marginTop}>
                {content}
            </NoDataText>
        </Box>
    );
};

export default NoData;
